import { render, staticRenderFns } from "./group-box.vue?vue&type=template&id=33875364&scoped=true"
import script from "./group-box.vue?vue&type=script&lang=js"
export * from "./group-box.vue?vue&type=script&lang=js"
import style0 from "./group-box.vue?vue&type=style&index=0&id=33875364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33875364",
  null
  
)

export default component.exports